import { VersionedDataContext } from "../../../contexts/versioned_data/context";
import { RunSelectorComponent } from "./component";
import { useContext, useMemo } from "react";

export const RunSelectorContainer = ({
  hideComparison = false,
}: {
  hideComparison?: boolean;
}) => {
  const {
    loading,
    mainRun,
    setMainRun,
    comparedRun,
    setComparedRun,
    atomicPivotRuns,
  } = useContext(VersionedDataContext);
  const successfulRuns = useMemo(
    () => atomicPivotRuns.filter((run) => run.status === "RUN_COMPLETED"),
    [atomicPivotRuns]
  );
  return (
    <RunSelectorComponent
      loading={loading}
      mainRun={mainRun}
      setMainRun={setMainRun}
      comparedRun={comparedRun}
      setComparedRun={setComparedRun}
      runs={successfulRuns}
      hideComparison={hideComparison}
    />
  );
};
